"use strict";
"use es6";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.delay = delay;

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _async = require("../scheduler/async");

var _isDate = require("../util/isDate");

var _Subscriber2 = require("../Subscriber");

var _Notification = require("../Notification");

/**
 * Delays the emission of items from the source Observable by a given timeout or
 * until a given Date.
 *
 * <span class="informal">Time shifts each item by some specified amount of
 * milliseconds.</span>
 *
 * <img src="./img/delay.png" width="100%">
 *
 * If the delay argument is a Number, this operator time shifts the source
 * Observable by that amount of time expressed in milliseconds. The relative
 * time intervals between the values are preserved.
 *
 * If the delay argument is a Date, this operator time shifts the start of the
 * Observable execution until the given date occurs.
 *
 * @example <caption>Delay each click by one second</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var delayedClicks = clicks.delay(1000); // each click emitted after 1 second
 * delayedClicks.subscribe(x => console.log(x));
 *
 * @example <caption>Delay all clicks until a future date happens</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var date = new Date('March 15, 2050 12:00:00'); // in the future
 * var delayedClicks = clicks.delay(date); // click emitted only after that date
 * delayedClicks.subscribe(x => console.log(x));
 *
 * @see {@link debounceTime}
 * @see {@link delayWhen}
 *
 * @param {number|Date} delay The delay duration in milliseconds (a `number`) or
 * a `Date` until which the emission of the source items is delayed.
 * @param {Scheduler} [scheduler=async] The IScheduler to use for
 * managing the timers that handle the time-shift for each item.
 * @return {Observable} An Observable that delays the emissions of the source
 * Observable by the specified timeout or Date.
 * @method delay
 * @owner Observable
 */
function delay(delay) {
  var scheduler = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _async.async;
  var absoluteDelay = (0, _isDate.isDate)(delay);
  var delayFor = absoluteDelay ? +delay - scheduler.now() : Math.abs(delay);
  return function (source) {
    return source.lift(new DelayOperator(delayFor, scheduler));
  };
}

var DelayOperator =
/*#__PURE__*/
function () {
  function DelayOperator(delay, scheduler) {
    (0, _classCallCheck2.default)(this, DelayOperator);
    this.delay = delay;
    this.scheduler = scheduler;
  }

  (0, _createClass2.default)(DelayOperator, [{
    key: "call",
    value: function call(subscriber, source) {
      return source.subscribe(new DelaySubscriber(subscriber, this.delay, this.scheduler));
    }
  }]);
  return DelayOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */


var DelaySubscriber =
/*#__PURE__*/
function (_Subscriber) {
  (0, _inherits2.default)(DelaySubscriber, _Subscriber);

  function DelaySubscriber(destination, delay, scheduler) {
    var _this;

    (0, _classCallCheck2.default)(this, DelaySubscriber);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(DelaySubscriber).call(this, destination));
    _this.delay = delay;
    _this.scheduler = scheduler;
    _this.queue = [];
    _this.active = false;
    _this.errored = false;
    return _this;
  }

  (0, _createClass2.default)(DelaySubscriber, [{
    key: "_schedule",
    value: function _schedule(scheduler) {
      this.active = true;
      this.add(scheduler.schedule(DelaySubscriber.dispatch, this.delay, {
        source: this,
        destination: this.destination,
        scheduler: scheduler
      }));
    }
  }, {
    key: "scheduleNotification",
    value: function scheduleNotification(notification) {
      if (this.errored === true) {
        return;
      }

      var scheduler = this.scheduler;
      var message = new DelayMessage(scheduler.now() + this.delay, notification);
      this.queue.push(message);

      if (this.active === false) {
        this._schedule(scheduler);
      }
    }
  }, {
    key: "_next",
    value: function _next(value) {
      this.scheduleNotification(_Notification.Notification.createNext(value));
    }
  }, {
    key: "_error",
    value: function _error(err) {
      this.errored = true;
      this.queue = [];
      this.destination.error(err);
    }
  }, {
    key: "_complete",
    value: function _complete() {
      this.scheduleNotification(_Notification.Notification.createComplete());
    }
  }], [{
    key: "dispatch",
    value: function dispatch(state) {
      var source = state.source;
      var queue = source.queue;
      var scheduler = state.scheduler;
      var destination = state.destination;

      while (queue.length > 0 && queue[0].time - scheduler.now() <= 0) {
        queue.shift().notification.observe(destination);
      }

      if (queue.length > 0) {
        var _delay = Math.max(0, queue[0].time - scheduler.now());

        this.schedule(state, _delay);
      } else {
        source.active = false;
      }
    }
  }]);
  return DelaySubscriber;
}(_Subscriber2.Subscriber);

var DelayMessage = function DelayMessage(time, notification) {
  (0, _classCallCheck2.default)(this, DelayMessage);
  this.time = time;
  this.notification = notification;
};